import ProductCarouselCard from '../card/ProductCarouselCard'
// https://flickity.metafizzy.co/api.html
export default {
  components: {
    Flickity: () => import('vue-flickity'),
    ProductCarouselCard
  },
  data () {
    return {
      flickityActive: false,
    }
  },
  async mounted() {
    await this.$nextTick()
    this.flickityActivator();
    window.addEventListener("resize", this.windowResize);
  },
  beforeDestory() {
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    next() {
      this.$refs.flickity.next();
    },
    previous() {
      this.$refs.flickity.previous();
    },
    windowResize() {
      this.flickityActivator();
    }
  }
}
